import * as log from 'loglevel';
log.enableAll()

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default class ServiceCaller {
  static async call(servicePromise, commit, mutator, errorMutator, inProgressMutator, reset) {
    try {
      commit(errorMutator, "")
      if (reset) commit(mutator, null)
      inProgressMutator && commit(inProgressMutator, true)
      let result = await servicePromise
      commit(mutator, this.parseData(result))
      inProgressMutator && commit(inProgressMutator, false)
    } catch (err) {
      if (err.response && err.response.status === 401) {
          await timeout(3000)
          window.location.reload()
      }
      commit(errorMutator, this.parseError(err))
      inProgressMutator && commit(inProgressMutator, false)
    }
  }

  static parseError(err) {
    if (err.response && err.response.data) {
      return new Error(err.response.data.message || "unknown error")
    }
    return err
  }

  static parseData(result) {
    return ((result || {}).data || {}).data
  }
}
